import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/data/content";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background/80 backdrop-blur-md border-b border-border py-4"
          : "bg-transparent py-7"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-12 flex items-center justify-between">
        <button
          data-testid="logo-home"
          onClick={() => go("#hero")}
          className={`font-display text-2xl tracking-tight transition-colors duration-500 ${
            scrolled ? "text-foreground" : "text-[#F7F5F0]"
          }`}
        >
          Form Pathway<span className="text-accent">.</span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className={`text-xs tracking-[0.18em] uppercase transition-colors duration-300 hover:text-accent ${
                scrolled ? "text-foreground/70" : "text-[#F7F5F0]/80"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden ${scrolled ? "text-foreground" : "text-[#F7F5F0]"}`}
          aria-label="Menu"
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-background border-t border-border mt-4"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                onClick={() => go(l.href)}
                className="text-left text-sm tracking-[0.15em] uppercase text-foreground/80"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
